import { render, staticRenderFns } from "./FieldEditVersions.vue?vue&type=template&id=c4d06202&"
import script from "./FieldEditVersions.vue?vue&type=script&lang=js&"
export * from "./FieldEditVersions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports